import { Component, OnInit, Input, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $;

@Component({
  selector: 'sw-seat-config-box',
  templateUrl: './sw-seat-config-box.component.html',
  styleUrls: ['./sw-seat-config-box.component.css']
})
export class SwSeatConfigBoxComponent implements OnInit {

  constructor(private el: ElementRef,
    private box: SwMassageBoxService,) { }

  ngOnInit() {
  }

  @Input() ids:any;

  @Input() elemId:any;

  @Input() dropdown: boolean = true;;

  @Input() configHeight: string = '150px';

  @Input() seatConfig:any=[]
  /**
 * 选中的id
 * @ignore
 */
@Input() selected :any= [];  


  /**
   * 搜索框的值
   */
  filter: any;

  /**
   * 选中数据
   */
  @Output() changeClick = new EventEmitter();
  @Output() closeSelect = new EventEmitter();

  ngAfterViewInit(): void {
    //浏览器的宽度
    let windowWidth = $(window).width()
    //如果有搜索框则给焦点
    let postion = document.getElementById(this.elemId).getBoundingClientRect()
    let wids = postion.width + 120
    this.el.nativeElement.style.position = 'fixed';
    this.el.nativeElement.style.zIndex = 9990;
    //this.el.nativeElement.style.top = postion.bottom + 'px';
    //this.el.nativeElement.style.left = postion.left + 'px';
    this.el.nativeElement.style.width = wids + 'px';

    let height = this.configHeight.split('px')[0]
    let clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    let heightAndTop = clientHeight + scrollTop
    if((heightAndTop-postion.bottom)<parseInt(height) ){ 
      this.el.nativeElement.style.top = postion.top - parseInt(height)+ 'px';
    }else {
      this.el.nativeElement.style.top = postion.bottom + 'px';
    }
    if(windowWidth - postion.left <wids){
      this.el.nativeElement.style.left = postion.right - wids + 3 + 'px';
    }else {
      this.el.nativeElement.style.left = postion.left + 'px';
    }
    this.myModalBodyScroll()  //监听 myModalBody 盒子的滚动条事件
    this.myWrapContScroll()  //监听 myWrapCont 盒子的滚动条事件
  }

  ngOnDestroy(): void {
    this.myModalBodyRmScroll()  //移除 myModalBody 盒子的滚动条事件
    this.myWrapContRmScroll()  //移除 myWrapCont 盒子的滚动条事件
  }



  clickConfig(event,config){
    event.stopPropagation()
    // console.log(config)
    // console.log(this.selected)
    this.selected = config.id
    this.changeClick.emit(config);
    
  }
  stopPro(event) {
    event.stopPropagation()
  }

  close(){
    this.closeSelect.emit(false)
  }

  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    //鉴定全屏键盘事件 如果是回车触发
    if(this.mouseo)
        this.closeSelect.emit(false)
  } 

  // //屏幕缩放时
  // @HostListener('window:resize', ['$event']) resize(event) {
  //   /* //屏幕缩放时,下拉框消失,否则下拉框
  //   this.closeSelect.emit(false) */
  //   //屏幕缩放时,重新设置下拉框的位置及宽度
  //   let postion = this.elem.nativeElement.getBoundingClientRect()
  //   this.el.nativeElement.style.top = postion.bottom + 'px';
  //   this.el.nativeElement.style.left = postion.left + 'px';
  //   this.el.nativeElement.style.width = postion.width + 'px';
  // }

  mouseo:boolean = true;
  mouseoverEvent(){
    this.mouseo = false;
  }
  mouseoutEvent(){
    this.mouseo = true;
  }

  //监听 myWrapCont 盒子的滚动条事件,滚动就让日期控件消失
  myWrapContScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myWrapContRmScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myWrapContScroll)
    }
  }

  //监听 myModalBody 盒子的滚动条事件,滚动就让日期控件消失
  myModalBodyScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myModalBodyRmScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myModalBodyScroll)
    }
  }

 //监听查看示例事件
 @HostListener('document:click', ['$event'])
 public onClick(event) {
      event.stopPropagation()
      setTimeout(()=>{
        if(this.elemId){
          const clickInside = this.el.nativeElement.contains(event.target) || document.getElementById(this.elemId).contains(event.target)
          if(!clickInside) {
           this.closeSelect.emit(false)
          }
        }
       
      },20)
 }

  // //创建新标签
  // add(){
  //   this.addNewClick.emit(this.filter)
  //   this.closeSelect.emit(false)  //销毁组件
  // }

}
